module.exports = __webpack_public_path__ + "img/afrikaans-first.c88ad0a8.svg";